// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"PhoneWidget_dropdown__21nfj","darkDropdown":"PhoneWidget_darkDropdown__2NDS-"};